import logo from "assets/img/logo/logo_aig_login-2.png";
import React, { Component } from "react";
import LoadingScreen from "react-loading-screen";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "../../components/Login/login.css";
import { loginMobileFetch } from "../../redux/actions/aLogin";
import "../../styles/estilos.css";
import rsa from "../../crypto/rsa";

class ContainerRecuperarSesionMovil extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataMobile: null,
      isLoading: true,
    };
  }

  onInitIniciarSesion = async () => {
    const queryParams = new URLSearchParams(this.props.location.search);
    let _data = queryParams.get("data");
    let _tipo = queryParams.get("tipo");
    console.log("_tipo", _tipo);
    console.log("URLDATA", `${_data}`);
    if (_tipo !== null && _tipo === "COTIZADOR") {
      if (_data !== undefined && _data !== null) {
        console.log("!=nullparameter", `${_data}`);
        const b64 = atob(`${_data}`);
        const decrypt = desencriptarRsa(b64);

        console.log("decrypt", decrypt);
        const data = JSON.parse(decrypt);
        console.log("desenCrypted", data);
        if (data !== undefined && data !== null) {
          await this.props.loginMobile(data);
          setTimeout(() => {
            if (this.props.datosUsuario.dataUsuario.userIsLoggedIn) {
              const user = this.props.datosUsuario.dataUsuario;
              console.log("UserLooged", user);
              console.log("Type", user.tipoCotizador);
              if (user != null && user !== undefined) {
                if (user.tipoCotizador === "VEHICULO") {
                  this.props.history.replace("/cotizacion?accion=nuevo");
                } else if (user.tipoCotizador === "HOGAR") {
                  this.props.history.replace(
                    "/cotizacion-hogar-datospersonales"
                  );
                } else if (user.tipoCotizador === "PYMES") {
                  this.props.history.replace("/pymes/cotizador?paso=1");
                } else if (user.tipoCotizador === "ACCIDENTE_PERSONAL") {
                  this.props.history.replace("/cotizacion-accidente-personal");
                } else if (user.tipoCotizador === "LINEA_FINANCIERA") {
                  this.props.history.replace(
                    "/cotizacion-financiero?idProducto=121"
                  );
                }
              }
            }
          }, 500);
        } else {
          alert("No desencripted data", data);
          console.log("No desencripted", data);
        }
      } else {
        console.log("No Data on url");
        alert("No Data on url", _data);
      }
    } else if (_tipo !== null && _tipo === "DETALLE_COTIZACION") {
      const b64 = atob(`${_data}`);
      const decrypt = desencriptarRsa(b64);
      console.log("decrypt", decrypt);
      const data = JSON.parse(decrypt);
      await this.props.loginMobile(data);
      setTimeout(() => {
        const urlCotizacion = data.urlCotizacion;
        const ramo = data.ramoNombre;
        this.handleOnClick({ url: urlCotizacion, ramo: ramo });
        console.log("tipo");
      }, 500);
    } else if (_tipo !== null && _tipo === "DETALLE_VENTA") {
      const b64 = atob(`${_data}`);
      const decrypt = desencriptarRsa(b64);
      console.log("decrypt", decrypt);
      const data = JSON.parse(decrypt);
      await this.props.loginMobile(data);
      setTimeout(() => {
        if (data !== undefined && data !== null) {
          const url = data.url;
          const forpago = data.forpago;
          this.onClick(url, forpago);
        }
      }, 500);
    }
  };
  onClick = async (id, forpago) => {
    console.log("Entre a evento onCLik con id: ", id);
    if (forpago !== "NI") {
      this.props.history.push({
        pathname: "/final-cotizacion-detalle",
        search: `?id=${id}&estado=APROBADO&resumen=1`, //agregar parametros de la url,
      });
    } else {
      this.props.history.push({
        pathname: "/forma-pago",
        search: `?id=${id}`, //agregar parametros de la url,
      });
    }
  };
  handleOnClick = async (params) => {
    const { url, ramo } = params;
    const param = new URLSearchParams(url);
    const id = param.get("id");
    if (ramo === "HOGAR") {
      if (url) {
        let i = url.indexOf("?id");
        this.props.history.push({
          pathname: `/${url.substring(0, i)}`,
          search: `${url.substring(i)}`, //agregar parametros de la url,
        });
      }
    } else if (ramo === "LÍNEAS FINANCIERAS") {
      if (url) {
        let i = url.indexOf("?id");
        this.props.history.push({
          pathname: `/${url.substring(0, i)}`,
          search: `${url.substring(i)}`, //agregar parametros de la url,
        });
      }
    } else if (ramo === "TRAVEL") {
      if (url) {
        let i = url.indexOf("?id");
        this.props.history.push({
          pathname: `/${url.substring(0, i)}`,
          search: `${url.substring(i)}`, //agregar parametros de la url,
        });
      }
    } else if (ramo === "ACCIDENTES PERSONALES") {
      if (url) {
        let i = url.indexOf("?id");
        this.props.history.push({
          pathname: `/${url.substring(0, i)}`,
          search: `${url.substring(i)}`, //agregar parametros de la url,
        });
      }
    } else if (ramo === "PYMES") {
      let i = url.indexOf("?id");
      this.props.history.push({
        pathname: "pymes/cotizador",
        search: `${url.substring(i)}`, //agregar parametros de la url,
      });
    } else if (ramo === "RCANDINA") {
      let i = url.indexOf("?id");
      this.props.history.push({
        pathname: "rc-andina/cotizador",
        search: `${url.substring(i)}`, //agregar parametros de la url,
      });
    } else {
      if (url) {
        let i = url.indexOf("?id");
        this.props.history.push({
          pathname: "/resumen-cotizacion",
          search: `${url.substring(i)}`, //agregar parametros de la url,
        });
      }
    }
  };
  componentDidMount = () => {
    console.clear();
    console.log("componentDidMount RecuperarSessionMobile");
    this.onInitIniciarSesion();
  };

  render() {
    return (
      <LoadingScreen
        loading={this.state.isLoading}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text="Iniciando sesión Móvil"
      ></LoadingScreen>
    );
  }
}

const mapStateToProps = (state) => ({
  datosUsuario: state.datosUsuarios,
  datosMovil: { ...state.datosUsuarios, mobile: true },
});

const mapDispatchToProps = (dispatch) => {
  return {
    loginMobile: (dataencrypted) => dispatch(loginMobileFetch(dataencrypted)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ContainerRecuperarSesionMovil)
);
export const desencriptarRsa = (trama) => {
  console.log("initDese", trama);
  try {
    const privateKeyAuth = `-----BEGIN RSA PRIVATE KEY-----
    MIIJJwIBAAKCAgEApVnxO7ix58fTJ1tNgV42puS076aUgR76DjmQcTNNFllQiXPB
    nwtuwH5BwuEzg8WT2dToC22e/oyNOA1eBBwBUEkJBjxLtsbk59BXO9C90PpQbOLZ
    pGGeSgb5HzwIxi4iExroSruo1gT+/IXr7A3GTJkIdbs9wxgtCxelKKVNeOsHITTv
    RC3di47cBZK/jNSgkfokdR0MjPTig9E6SlKdZXnxikJckOmj2uQgskb1qUcJ7zbR
    stIpXQtJCSFltf/QvocrFTQzsBntHk2eSVDuoGnJNj/x2fG6DB1z8zU/sr2RPiUT
    DBin8lXQQ1im/n/EaR141CXOYhLB2G42UlQ1A0mSfQUc8cVVrpBOeYLSjHd7IOcy
    KdXjG5VISBDhABUrr4krU7eDjIFtc/hkQ5J3v9p65dBbbLHfbu0t6+RihW2y+GOY
    nypRx34h2TK2OBZO3357iaqdCqx4RuROHkuY2iaHRJZOZZ5rsYYMKt9p19UgBzkU
    wHLE+JwE0mFi4596HuZmjVgb4hlBbKEFwudP124Unm579U9BkmSe6Wq8aJ8lkuXr
    KyD2Ple/0XhUtD9es7cjm2HGhsUhF+EnWUbAamhg/whLyIG9j4RH+PfEr7rjS5GJ
    Vgc8T8XSoh3D0naK5ZteFaxUr4loJZmgSrRV/qJDxhKPpPi+yHOZ/vL5Rr0CAwEA
    AQKCAgBq+JsFxeDiT/YcugaUMP0uTzt25s+gEQg4d6kocsXmNXXS1p5mZCEMSyIE
    D2kiUInsHL7Z1dtMVmVt48f05KE87WL3M77PyjCAf9pPiiWisq2hI8klfTnILmaw
    fEg43dORhJDO+ESr4KONfp44IlktaLt+XtoAAv3w9SUV/Ir4NSRxqSs5cmqnRI62
    1E8zrsMKbUd0tIxQDIUWPh91wait44wNpAz6ewxUKc21SA7ZqmmU5mQXSbsUxJ5F
    V+PTMGI9QHjwyMq/nKY4OoKyb7dQ898GR6wRET8JY2yF5OcGnXj/OUDvTGwqbLXF
    O+8dKk9IqZZnuOWhsPzTJcnizTNVlRmka5TmCwEn04p7hAxFlhCOpPN3WVfmqWKS
    2KuLwtjWA7/YMmI71pEpgPcGYEoraxFXCP6DzUE9/6llAVT52+ybFIrKc0N6CzFY
    T94J3lE4SbIUT2CHTPYEyu+7I3pL9L45EJdYOgCronu13TpiCFEEcEKPhUtXfreE
    onGysew8t4U4Z5CnB65dEcPUQ0sEVykGcOHLKYgIu9ZGM9Snx3az30mSd/bFGMDU
    9QnKMuGpVTuxEO6ukByEyhN8MVFJJMrTHtdOBupzpoevQcoZ23hJcOLIgxowewc1
    oevnDW8JuX4MUbc2Z3k8NEZkidUJTMFBSrJt0Xy40zCz5PDOwQKCAQEA85rtQeHG
    NOBiiNg9UQkUZ/hiknT4NNoXGrHVHL7Fyj/K53zgW/gntrab17ARBOA63EoUaN2V
    f/qjPX/SUuXW+GuFk14RIV/7AckAsh6ecEXyKTWpPoq+jVGOrLRvo8N5do0MMtK8
    AUGVVMNs6MFjp4KxA/NW8wHv+kw4dPBBDXCg6+3wM1H0kXonKtlVa0wHyn1Jxxk7
    pKiv+nlKFyzw67AtLh8jvCbawh7S246EN0psZFH5DbTrM/aeXo0MPIgL9RkKQwCU
    e0wx465H2+WgqIKsH/IP4CZBB1Rveuq9w81EknYgD/oGsw36ZlpqupbMUH2xmF4y
    GPbv+gZ+hEYklQKCAQEArcO41oI0JqQDoQsHnLi72nvkX55vMywDio6Mxtu2jYFR
    G2u+Lesq3s1/nA62HRaSw6Q3TMUe5Elq8ItOBbHktdjNPnKR0H1OLanLXktLFGc/
    19lWT874JeG39TP9TK/cYEMsPDWUkb9Jo8fy73imNHrCK/VxzupDliuX3vTz6r32
    9Sh3Mi/SZ9QwK7gltbHEyBa5JrbJS/+T1ixTB4MtMOz9ibrxWIJckjlPulsgRK15
    VkpkiBHaLTGkcvA+l5XiDfaZsfgzCJn/iXd4OMkFsPihasdXHsYLVNFAuNdcNFcb
    yNgUn5r85P2VbJH2DJmiG811So4LcX+82G+zpikniQKCAQA5wmss6s5nLSjPz43C
    UAfRmxgsJ6XOSkOeJbolBaq6CKQgfQBpbg5kiSmsW2e9ozjxkHMEZj2TSac45rzE
    wRBWeJAEYBJpums2giUzFoV0k3EWik2lsZn6wfK1SlcKGkgLbugMiODg31776RZC
    nc/2IMu95w2fsr7mtvnP6ENUX3cYWaNRV8ZIVBFDXKKfPTi/rzM2DOqSYRjQp7+E
    fThmebBMtj9v1jqaOlq+ii0ZOwE2TCVkNZhrCreELadQFuXW6GgBePq7vVY66NDK
    98g/DDSpomhXOlrC1SdVmqEB8wKmQ3HYt+ysucy8RgX2Vdj94L+iI/t25d4Ch1Wq
    IUN9AoIBAEl5C6vwDBsWmM48erCC0DOW1T61IDHT939bvRzMhEkbF+9vRE/oMw1Y
    eQ/EjK6J/+6nfhaA9wnyHTyuuoPf72QQ0uAH064Dfc4DEJHDZnCvI6iiJkPCsNxb
    r8wHeqA1cApn/MlMopBqALo27nrhWe2wxm+N7dxe48sYjbPhgU2Nm2GYBaZ74Ay1
    BNVHnPJRw3ITYaCEA2OWIq2ZulXf2njojF/zYt9Y58mQYCzdISzI6Rhahl2eptEb
    P3y2JtEzuAzNa7l7yCBn9Uvr7zKblUN6Lc6XkTfa56mqfSJrNXqQJphq/XVrNGmi
    686nfRFg2NHGs0SeASqxp2kg+iZVGnkCggEACn1wGMWYjU9zPD3K4qk6mj4XSJcq
    vz/1iClT8i/+ZeB++mGhKiRRZirhQbpJAStt1gNTDa8MPFr+VApp4c2Dr4kuVFt+
    N/FgjICeCozxMylS7pJQBcvoL9CmS783xWZNSNHCwjt0CWwRJIaRlJRx2siGaClt
    qLwhXBJ8XXpSr/Xbg3HtiCI600lnnHMbVMnNBE+u7y8S8TL1NH80biL27a/VwQji
    V8fQ58/dpaRiJqQYuBVPiJR/39x/uZ0UJe4VRXSC04pR1zfCVDhC3n1xU0NwNf+S
    EXgF8TyCck/lDf2DYl5VsaZcSa+J5yi1O0fQwmMS9Edn7G9wYghptfG/bg==
    -----END RSA PRIVATE KEY-----`;
    var rsa_ = new rsa();
    rsa_.setPrivateCert(privateKeyAuth);
    //rsa_.setPrivateCert(privateKey2);

    var result = rsa_.decrypt(`${trama}`);
    console.log("result rsa", result);
    return result;
  } catch (error) {
    alert("error", error);
    return "error";
  }
};
